export default __webpack_public_path__ + "static/media/fact_sheet45.7c8a91cb.png";